import {
    ref,
    onMounted,
    onUnmounted,
    Ref,
} from '@vue/composition-api';

export function useClickOutside(elementRef: Ref<HTMLElement | null>) {
    const isClickOutside = ref(false);

    const handleClickOutside = (event: Event) => {
        isClickOutside.value = !!(elementRef.value && !elementRef.value.contains(event.target as Node));
    };

    onMounted(() => {
        document.addEventListener('click', handleClickOutside);
    });

    onUnmounted(() => {
        document.removeEventListener('click', handleClickOutside);
    });

    return { isClickOutside };
}
